/*
 * TypingLayouts — раскладки клавиатуры для курса слепой печати (/typing-course).
 *
 * Урок курса — это ФИЗИЧЕСКИЕ клавиши (KeyboardEvent.code: KeyF, KeyJ…), а
 * буквы на них даёт раскладка ученика: KeyF — «а» в ЙЦУКЕН, «f» в QWERTY,
 * «ب» в арабской, «ㄹ» в 두벌식. Поэтому одна программа учит всех: пальцы и
 * зоны одинаковы, меняются только подписи.
 *
 *   TypingLayouts.get(id)               → раскладка {id, script, keys, dead, byCode}
 *   TypingLayouts.forLocale(locale)     → {def, options[]} — раскладки языка страницы
 *   TypingLayouts.finger(code)          → 'LP'…'RP' | 'TH'
 *   TypingLayouts.rows(layout)          → ряды кодов для рисунка клавиатуры
 *   TypingLayouts.units(text, layout)   → единицы набора: {ch, strokes:[{code,shift}], key}
 *   TypingLayouts.typable(word, layout, codes, shiftOk) → набирается ли слово
 *   TypingLayouts.label(layout, code, shift) → подпись клавиши
 *   TypingLayouts.detect()              → Promise<id|null> (Chromium: getLayoutMap)
 *
 * Корейский (byCode) сверяется по физической клавише: IME во время набора
 * отдаёт e.key = 'Process', а слог складывает сам — честная проверка там
 * одна, по коду клавиши каждой чамо.
 */
(function (root) {
    'use strict';

    var FINGER = {
        Backquote: 'LP', Digit1: 'LP', Digit2: 'LR', Digit3: 'LM', Digit4: 'LI', Digit5: 'LI',
        Digit6: 'RI', Digit7: 'RI', Digit8: 'RM', Digit9: 'RR', Digit0: 'RP', Minus: 'RP', Equal: 'RP',
        KeyQ: 'LP', KeyW: 'LR', KeyE: 'LM', KeyR: 'LI', KeyT: 'LI', KeyY: 'RI', KeyU: 'RI', KeyI: 'RM',
        KeyO: 'RR', KeyP: 'RP', BracketLeft: 'RP', BracketRight: 'RP', Backslash: 'RP',
        KeyA: 'LP', KeyS: 'LR', KeyD: 'LM', KeyF: 'LI', KeyG: 'LI', KeyH: 'RI', KeyJ: 'RI', KeyK: 'RM',
        KeyL: 'RR', Semicolon: 'RP', Quote: 'RP',
        IntlBackslash: 'LP', KeyZ: 'LP', KeyX: 'LR', KeyC: 'LM', KeyV: 'LI', KeyB: 'LI', KeyN: 'RI',
        KeyM: 'RI', Comma: 'RM', Period: 'RR', Slash: 'RP', IntlRo: 'RP',
        Space: 'TH', ShiftLeft: 'LP', ShiftRight: 'RP'
    };
    var LEFT = { LP: 1, LR: 1, LM: 1, LI: 1 };

    var ROWS = [
        ['Backquote', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0', 'Minus', 'Equal'],
        ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight', 'Backslash'],
        ['KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote'],
        ['IntlBackslash', 'KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period', 'Slash', 'IntlRo']
    ];

    function letters(codes, chars, upper) {
        var o = {};
        for (var i = 0; i < codes.length; i++) {
            var c = chars[i];
            o[codes[i]] = [c, upper === false ? c : c.toLocaleUpperCase()];
        }
        return o;
    }
    function assign(a) {
        for (var i = 1; i < arguments.length; i++) {
            var b = arguments[i];
            for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k];
        }
        return a;
    }
    var LATIN_LETTERS = letters(
        ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP',
         'KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL',
         'KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM'],
        'qwertyuiopasdfghjklzxcvbnm'.split(''));
    var DIGITS_US = {
        Backquote: ['`', '~'], Digit1: ['1', '!'], Digit2: ['2', '@'], Digit3: ['3', '#'], Digit4: ['4', '$'],
        Digit5: ['5', '%'], Digit6: ['6', '^'], Digit7: ['7', '&'], Digit8: ['8', '*'], Digit9: ['9', '('],
        Digit0: ['0', ')'], Minus: ['-', '_'], Equal: ['=', '+']
    };
    var PUNCT_US = {
        BracketLeft: ['[', '{'], BracketRight: [']', '}'], Backslash: ['\\', '|'],
        Semicolon: [';', ':'], Quote: ["'", '"'], Comma: [',', '<'], Period: ['.', '>'], Slash: ['/', '?']
    };
    var DIGITS_RU = {
        Digit1: ['1', '!'], Digit2: ['2', '"'], Digit3: ['3', '№'], Digit4: ['4', ';'], Digit5: ['5', '%'],
        Digit6: ['6', ':'], Digit7: ['7', '?'], Digit8: ['8', '*'], Digit9: ['9', '('], Digit0: ['0', ')'],
        Minus: ['-', '_'], Equal: ['=', '+']
    };

    var L = {};

    L.qwerty = { id: 'qwerty', script: 'latin', keys: assign({}, DIGITS_US, PUNCT_US, LATIN_LETTERS) };

    L.jcuken = { id: 'jcuken', script: 'cyrillic', keys: assign({ Backquote: ['ё', 'Ё'] }, DIGITS_RU, letters(
        ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight',
         'KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote',
         'KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period'],
        'йцукенгшщзхъфывапролджэячсмитьбю'.split('')), { Backslash: ['\\', '/'], Slash: ['.', ','] }) };

    // Украинская (расширенная): ' на месте ё, ї вместо ъ, і вместо ы, є вместо э, ґ — на обратном слэше.
    L.jcuken_ua = { id: 'jcuken_ua', script: 'cyrillic', keys: assign({ Backquote: ["'", '₴'] }, DIGITS_RU, letters(
        ['KeyQ', 'KeyW', 'KeyE', 'KeyR', 'KeyT', 'KeyY', 'KeyU', 'KeyI', 'KeyO', 'KeyP', 'BracketLeft', 'BracketRight', 'Backslash',
         'KeyA', 'KeyS', 'KeyD', 'KeyF', 'KeyG', 'KeyH', 'KeyJ', 'KeyK', 'KeyL', 'Semicolon', 'Quote',
         'KeyZ', 'KeyX', 'KeyC', 'KeyV', 'KeyB', 'KeyN', 'KeyM', 'Comma', 'Period'],
        'йцукенгшщзхїґфівапролджєячсмитьбю'.split('')), { Slash: ['.', ','] }) };

    L.qwertz = { id: 'qwertz', script: 'latin', keys: assign({}, LATIN_LETTERS, letters(['KeyY', 'KeyZ'], ['z', 'y']), {
        Backquote: ['^', '°'], Digit1: ['1', '!'], Digit2: ['2', '"'], Digit3: ['3', '§'], Digit4: ['4', '$'], Digit5: ['5', '%'],
        Digit6: ['6', '&'], Digit7: ['7', '/'], Digit8: ['8', '('], Digit9: ['9', ')'], Digit0: ['0', '='], Minus: ['ß', '?'],
        Equal: ['´', '`'], BracketLeft: ['ü', 'Ü'], BracketRight: ['+', '*'], Backslash: ['#', "'"], Semicolon: ['ö', 'Ö'],
        Quote: ['ä', 'Ä'], IntlBackslash: ['<', '>'], Comma: [',', ';'], Period: ['.', ':'], Slash: ['-', '_']
    }), dead: { Equal: { '': '´', s: '`' }, Backquote: { '': '^' } } };

    L.azerty = { id: 'azerty', script: 'latin', keys: assign({}, LATIN_LETTERS, letters(
        ['KeyQ', 'KeyW', 'KeyA', 'KeyZ', 'Semicolon'], ['a', 'z', 'q', 'w', 'm']), {
        Backquote: ['²', '²'], Digit1: ['&', '1'], Digit2: ['é', '2'], Digit3: ['"', '3'], Digit4: ["'", '4'], Digit5: ['(', '5'],
        Digit6: ['-', '6'], Digit7: ['è', '7'], Digit8: ['_', '8'], Digit9: ['ç', '9'], Digit0: ['à', '0'], Minus: [')', '°'],
        Equal: ['=', '+'], BracketLeft: ['^', '¨'], BracketRight: ['$', '£'], Backslash: ['*', 'µ'], Quote: ['ù', '%'],
        IntlBackslash: ['<', '>'], KeyM: [',', '?'], Comma: [';', '.'], Period: [':', '/'], Slash: ['!', '§']
    }), digitsShift: true, dead: { BracketLeft: { '': '^', s: '¨' } } };

    L.es_la = { id: 'es_la', script: 'latin', keys: assign({}, LATIN_LETTERS, {
        Backquote: ['|', '°'], Digit1: ['1', '!'], Digit2: ['2', '"'], Digit3: ['3', '#'], Digit4: ['4', '$'], Digit5: ['5', '%'],
        Digit6: ['6', '&'], Digit7: ['7', '/'], Digit8: ['8', '('], Digit9: ['9', ')'], Digit0: ['0', '='], Minus: ["'", '?'],
        Equal: ['¿', '¡'], BracketLeft: ['´', '¨'], BracketRight: ['+', '*'], Backslash: ['}', ']'], Semicolon: ['ñ', 'Ñ'],
        Quote: ['{', '['], IntlBackslash: ['<', '>'], Comma: [',', ';'], Period: ['.', ':'], Slash: ['-', '_']
    }), dead: { BracketLeft: { '': '´', s: '¨' } } };

    L.es_es = { id: 'es_es', script: 'latin', keys: assign({}, LATIN_LETTERS, {
        Backquote: ['º', 'ª'], Digit1: ['1', '!'], Digit2: ['2', '"'], Digit3: ['3', '·'], Digit4: ['4', '$'], Digit5: ['5', '%'],
        Digit6: ['6', '&'], Digit7: ['7', '/'], Digit8: ['8', '('], Digit9: ['9', ')'], Digit0: ['0', '='], Minus: ["'", '?'],
        Equal: ['¡', '¿'], BracketLeft: ['`', '^'], BracketRight: ['+', '*'], Backslash: ['ç', 'Ç'], Semicolon: ['ñ', 'Ñ'],
        Quote: ['´', '¨'], IntlBackslash: ['<', '>'], Comma: [',', ';'], Period: ['.', ':'], Slash: ['-', '_']
    }), dead: { Quote: { '': '´', s: '¨' }, BracketLeft: { '': '`', s: '^' } } };

    L.abnt2 = { id: 'abnt2', script: 'latin', keys: assign({}, LATIN_LETTERS, {
        Backquote: ["'", '"'], Digit1: ['1', '!'], Digit2: ['2', '@'], Digit3: ['3', '#'], Digit4: ['4', '$'], Digit5: ['5', '%'],
        Digit6: ['6', '¨'], Digit7: ['7', '&'], Digit8: ['8', '*'], Digit9: ['9', '('], Digit0: ['0', ')'], Minus: ['-', '_'],
        Equal: ['=', '+'], BracketLeft: ['´', '`'], BracketRight: ['[', '{'], Backslash: [']', '}'], Semicolon: ['ç', 'Ç'],
        Quote: ['~', '^'], IntlBackslash: ['\\', '|'], Comma: [',', '<'], Period: ['.', '>'], Slash: [';', ':'], IntlRo: ['/', '?']
    }), dead: { BracketLeft: { '': '´', s: '`' }, Quote: { '': '~', s: '^' } } };

    L.arabic = { id: 'arabic', script: 'arabic', keys: assign({}, DIGITS_US, {
        Backquote: ['ذ', 'ّ'], Digit9: ['9', ')'], Digit0: ['0', '('],
        KeyQ: ['ض', 'َ'], KeyW: ['ص', 'ً'], KeyE: ['ث', 'ُ'], KeyR: ['ق', 'ٌ'], KeyT: ['ف', 'لإ'], KeyY: ['غ', 'إ'],
        KeyU: ['ع', '‘'], KeyI: ['ه', '÷'], KeyO: ['خ', '×'], KeyP: ['ح', '؛'], BracketLeft: ['ج', '<'], BracketRight: ['د', '>'],
        Backslash: ['\\', '|'], KeyA: ['ش', 'ِ'], KeyS: ['س', 'ٍ'], KeyD: ['ي', ']'], KeyF: ['ب', '['], KeyG: ['ل', 'لأ'],
        KeyH: ['ا', 'أ'], KeyJ: ['ت', 'ـ'], KeyK: ['ن', '،'], KeyL: ['م', '/'], Semicolon: ['ك', ':'], Quote: ['ط', '"'],
        KeyZ: ['ئ', '~'], KeyX: ['ء', 'ْ'], KeyC: ['ؤ', '}'], KeyV: ['ر', '{'], KeyB: ['لا', 'لآ'], KeyN: ['ى', 'آ'],
        KeyM: ['ة', '’'], Comma: ['و', ','], Period: ['ز', '.'], Slash: ['ظ', '؟']
    }) };

    L.dubeolsik = { id: 'dubeolsik', script: 'hangul', byCode: true, keys: assign({}, DIGITS_US, PUNCT_US, {
        KeyQ: ['ㅂ', 'ㅃ'], KeyW: ['ㅈ', 'ㅉ'], KeyE: ['ㄷ', 'ㄸ'], KeyR: ['ㄱ', 'ㄲ'], KeyT: ['ㅅ', 'ㅆ'], KeyY: ['ㅛ', 'ㅛ'],
        KeyU: ['ㅕ', 'ㅕ'], KeyI: ['ㅑ', 'ㅑ'], KeyO: ['ㅐ', 'ㅒ'], KeyP: ['ㅔ', 'ㅖ'], KeyA: ['ㅁ', 'ㅁ'], KeyS: ['ㄴ', 'ㄴ'],
        KeyD: ['ㅇ', 'ㅇ'], KeyF: ['ㄹ', 'ㄹ'], KeyG: ['ㅎ', 'ㅎ'], KeyH: ['ㅗ', 'ㅗ'], KeyJ: ['ㅓ', 'ㅓ'], KeyK: ['ㅏ', 'ㅏ'],
        KeyL: ['ㅣ', 'ㅣ'], KeyZ: ['ㅋ', 'ㅋ'], KeyX: ['ㅌ', 'ㅌ'], KeyC: ['ㅊ', 'ㅊ'], KeyV: ['ㅍ', 'ㅍ'], KeyB: ['ㅠ', 'ㅠ'],
        KeyN: ['ㅜ', 'ㅜ'], KeyM: ['ㅡ', 'ㅡ']
    }) };

    /* Буква с акцентом через мёртвую клавишу: акцент → базовая буква. */
    var ACCENTS = {
        '´': { a: 'á', e: 'é', i: 'í', o: 'ó', u: 'ú', A: 'Á', E: 'É', I: 'Í', O: 'Ó', U: 'Ú' },
        '`': { a: 'à', e: 'è', i: 'ì', o: 'ò', u: 'ù', A: 'À', E: 'È' },
        '^': { a: 'â', e: 'ê', i: 'î', o: 'ô', u: 'û', A: 'Â', E: 'Ê', O: 'Ô' },
        '¨': { a: 'ä', e: 'ë', i: 'ï', o: 'ö', u: 'ü', y: 'ÿ', U: 'Ü' },
        '~': { a: 'ã', o: 'õ', n: 'ñ', A: 'Ã', O: 'Õ' }
    };

    var LOCALE = {
        ru: { def: 'jcuken', options: ['jcuken'] },
        uk: { def: 'jcuken_ua', options: ['jcuken_ua'] },
        en: { def: 'qwerty', options: ['qwerty', 'qwertz', 'azerty'] },
        id: { def: 'qwerty', options: ['qwerty'] },
        de: { def: 'qwertz', options: ['qwertz', 'qwerty'] },
        fr: { def: 'azerty', options: ['azerty', 'qwerty'] },
        es: { def: 'es_la', options: ['es_la', 'es_es', 'qwerty'] },
        pt: { def: 'abnt2', options: ['abnt2', 'qwerty'] },
        ar: { def: 'arabic', options: ['arabic'] },
        ko: { def: 'dubeolsik', options: ['dubeolsik'] }
    };

    /* ── обратная карта: символ → удар ─────────────────────────────── */
    var REV = {};
    function rev(layout) {
        if (REV[layout.id]) return REV[layout.id];
        var m = {};
        var put = function (ch, code, shift) {
            if (!ch || m[ch]) return;
            m[ch] = { code: code, shift: shift };
        };
        ROWS.concat([['Space']]).forEach(function (row) {
            row.forEach(function (code) {
                var k = layout.keys[code];
                if (!k) return;
                put(k[0], code, false);
                if (k[1] !== k[0]) put(k[1], code, true);
            });
        });
        // На AZERTY цифры — с Shift: обратная карта это уже знает (Digit1 → ['&','1']).
        m[' '] = { code: 'Space', shift: false };
        REV[layout.id] = m;
        return m;
    }
    function deadOf(layout, accentChar) {
        var d = layout.dead || {};
        for (var code in d) {
            if (!Object.prototype.hasOwnProperty.call(d, code)) continue;
            if (d[code][''] === accentChar) return { code: code, shift: false };
            if (d[code].s === accentChar) return { code: code, shift: true };
        }
        return null;
    }

    /* ── хангыль: слог → чамо (두벌식) ─────────────────────────────── */
    var CHO = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ'.split('');
    var JUNG = 'ㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣ'.split('');
    var JONG = ['', 'ㄱ', 'ㄲ', 'ㄳ', 'ㄴ', 'ㄵ', 'ㄶ', 'ㄷ', 'ㄹ', 'ㄺ', 'ㄻ', 'ㄼ', 'ㄽ', 'ㄾ', 'ㄿ', 'ㅀ', 'ㅁ', 'ㅂ', 'ㅄ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
    var SPLIT = {
        'ㅘ': 'ㅗㅏ', 'ㅙ': 'ㅗㅐ', 'ㅚ': 'ㅗㅣ', 'ㅝ': 'ㅜㅓ', 'ㅞ': 'ㅜㅔ', 'ㅟ': 'ㅜㅣ', 'ㅢ': 'ㅡㅣ',
        'ㄳ': 'ㄱㅅ', 'ㄵ': 'ㄴㅈ', 'ㄶ': 'ㄴㅎ', 'ㄺ': 'ㄹㄱ', 'ㄻ': 'ㄹㅁ', 'ㄼ': 'ㄹㅂ', 'ㄽ': 'ㄹㅅ',
        'ㄾ': 'ㄹㅌ', 'ㄿ': 'ㄹㅍ', 'ㅀ': 'ㄹㅎ', 'ㅄ': 'ㅂㅅ'
    };
    function jamo(ch) {
        var c = ch.charCodeAt(0);
        if (c >= 0xAC00 && c <= 0xD7A3) {
            var s = c - 0xAC00;
            var out = CHO[Math.floor(s / 588)] + JUNG[Math.floor((s % 588) / 28)] + JONG[s % 28];
            return out.split('').map(function (j) { return SPLIT[j] || j; }).join('').split('');
        }
        if (SPLIT[ch]) return SPLIT[ch].split('');
        return [ch];
    }

    /* Удары одного символа; null — символ этой раскладкой не набрать. */
    function strokesOf(ch, layout) {
        var m = rev(layout);
        if (layout.script === 'hangul' && /[ㄱ-ㆎ가-힣]/.test(ch)) {
            var js = jamo(ch), st = [];
            for (var i = 0; i < js.length; i++) {
                var s = m[js[i]];
                if (!s) return null;
                st.push(s);
            }
            return st;
        }
        if (m[ch]) return [m[ch]];
        // Буква с акцентом: мёртвая клавиша + база.
        for (var acc in ACCENTS) {
            if (!Object.prototype.hasOwnProperty.call(ACCENTS, acc)) continue;
            var tbl = ACCENTS[acc];
            for (var base in tbl) {
                if (tbl[base] !== ch) continue;
                var d = deadOf(layout, acc);
                var b = m[base];
                if (d && b) return [{ code: d.code, shift: d.shift, dead: true }, b];
            }
        }
        return null;
    }

    function units(text, layout) {
        var out = [];
        var chars = Array.from(String(text).normalize('NFC'));
        for (var i = 0; i < chars.length; i++) {
            var ch = chars[i];
            // «لا» — одна клавиша, два символа.
            if (layout.id === 'arabic' && ch === 'ل' && chars[i + 1] === 'ا') {
                out.push({ ch: 'لا', strokes: [{ code: 'KeyB', shift: false }], alt: [{ code: 'KeyG', shift: false }, { code: 'KeyH', shift: false }] });
                i++;
                continue;
            }
            var st = strokesOf(ch, layout);
            if (!st) continue;
            out.push({ ch: ch, strokes: st });
        }
        return out;
    }

    function typable(word, layout, allowed, shiftOk) {
        var chars = Array.from(String(word));
        for (var i = 0; i < chars.length; i++) {
            var st = strokesOf(chars[i], layout);
            if (!st) return false;
            for (var k = 0; k < st.length; k++) {
                if (!allowed[st[k].code]) return false;
                if (st[k].shift && !shiftOk) {
                    // В 두벌식 Shift на ㅛ/ㅁ… не меняет букву — но и не нужен.
                    return false;
                }
            }
        }
        return true;
    }

    function label(layout, code, shift) {
        if (code === 'Space') return '␣';
        var k = layout.keys[code];
        if (!k) return '';
        var s = shift ? k[1] : k[0];
        // На колпачке буква заглавная (как на клавиатуре); ß заглавной формы в одну букву не имеет.
        if (!shift && layout.script !== 'hangul' && layout.script !== 'arabic' && s.length === 1) {
            var up = s.toLocaleUpperCase();
            if (up.length === 1 && up !== s) return up;
        }
        return s;
    }

    function rows(layout) {
        return ROWS.map(function (row) {
            return row.filter(function (code) { return !!layout.keys[code]; });
        });
    }

    function detect() {
        try {
            if (!navigator.keyboard || !navigator.keyboard.getLayoutMap) return Promise.resolve(null);
            return navigator.keyboard.getLayoutMap().then(function (map) {
                var g = function (c) { return String(map.get(c) || ''); };
                if (/[а-яё]/i.test(g('KeyQ'))) return g('KeyS') === 'і' ? 'jcuken_ua' : 'jcuken';
                if (/[؀-ۿ]/.test(g('KeyF'))) return 'arabic';
                if (g('KeyQ') === 'a') return 'azerty';
                if (g('KeyY') === 'z') return 'qwertz';
                if (g('Semicolon') === 'ç') return 'abnt2';
                if (g('Semicolon') === 'ñ') return g('Quote') === '´' ? 'es_es' : 'es_la';
                if (g('KeyQ') === 'q') return 'qwerty';
                return null;
            }, function () { return null; });
        } catch (_) { return Promise.resolve(null); }
    }

    root.TypingLayouts = {
        get: function (id) { return L[id] || L.qwerty; },
        has: function (id) { return !!L[id]; },
        forLocale: function (loc) { return LOCALE[loc] || LOCALE.en; },
        finger: function (code) { return FINGER[code] || ''; },
        leftHand: function (code) { return !!LEFT[FINGER[code]]; },
        rows: rows,
        units: units,
        strokesOf: strokesOf,
        typable: typable,
        label: label,
        jamo: jamo,
        detect: detect,
        accents: ACCENTS
    };
})(typeof self !== 'undefined' ? self : this);
